<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-9">
        <div class="box">
          <div class="box-header with-border">
            <h3 v-if="currentCase" class="box-title">{{currentCase.name}}</h3>
            <!-- <span v-if="currentCase" class="pull-right">{{currentCase.creationDate | prettyDateTime}}</span> -->
            <i data-toggle="tooltip" data-placement="bottom" title="Delete" class="fa fa-trash clickable pull-right" v-on:click="confirm"></i>
            <i data-toggle="tooltip" data-placement="bottom" title="Link" class="fa fa-link clickable pull-right" v-on:click="openLinkModal"></i>
          </div>
          <!-- /.box-header -->
          <div class="box-body">

            <testimonies-list :globalEnpoint="firstGlobalEnpoint" :searchEndpoint="firstSearchEndpoint" :searchEnabled="firstSearchEnabled" :additionalQueryParam="firstAdditionalQueryParam" ref="testimoniesListRef" @loaded="onTestimoniesLoaded"/>

            <!-- /.box-body -->
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="row">
          <signaletics v-if="currentCase" :id="id" :status="this.currentCase.status" type="cases"></signaletics>
        </div>

        <div class="row">
          <anchors v-if="currentCase" :id="id" type="cases" anchorDone="refresh"/>
        </div>

        <div class="row">
          <div class="box">
            <div class="box-header with-border">
              <h3 class="box-title">Testimonies localisation</h3>
            </div>
            <div class="box-body">
              <osm-map :markers="testimoniesMarkers"></osm-map>
            </div>
          </div>
        </div>
      </div>
    </div>

<confirm-modal message="Do you really want to archive this case ?" title="Archive Confirmation" @confirm="archive()" id="ConfirmModal"></confirm-modal>
    <link-testimony-modal ref="linkTestimonyModal" @link="linkAll" id="LinkTestimonyModal" :preselected="testimonies" ></link-testimony-modal>
  </section>
</template>

<script>
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import api from '../../api'
import helper from '../../helper'
import async from 'async'

export default {
  name: 'Cases',
  data () {
    return {
      firstGlobalEnpoint: `/cases/${this.$route.params.id}/testimonies`,
      firstSearchEndpoint: '/testimonies/search',
      firstAdditionalQueryParam: '',
      secondGlobalEnpoint: `/testimonies`,
      secondSearchEndpoint: '/testimonies/search',
      secondAdditionalQueryParam: `&notInCase=${this.$route.params.id}`,
      firstSearchEnabled: false,
      secondSearchEnabled: true,
      id: this.$route.params.id,
      currentCase: null,
      testimonies: [],
      testimoniesMarkers: []
    }
  },
  methods: {
    refresh () {
      console.log('refresh')
    },
    getCase () {
      api.authenticatedRequest('get', `/cases/${this.id}`)
      .then(response => {
        this.currentCase = response.data
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 401) { // InvalidCredentialsError
          this.response = 'Username/Password incorrect. Please try again.'
          return
        }
        this.response = 'Server appears to be offline'
      })
    },
    onTestimoniesLoaded ($event) {
      this.testimoniesMarkers = helper.extractTestimoniesMarkers($event, true)
    },
    confirm () {
      window.jQuery('#ConfirmModal').modal({})
    },
    archive () {
      // api.authenticatedRequest('delete', `/testimonies/${this.id}?version=${this.testimony.version}`)
      // .then(response => {
      //   this.$router.push({name: 'Testimonies'})
      // })
      // .catch(error => {
      //   console.log(error)
      //   this.goToReadMode()
      //   if (error.response.status === 401) { // InvalidCredentialsError
      //     this.response = 'Username/Password incorrect. Please try again.'
      //     return
      //   }
      //   this.response = 'Server appears to be offline'
      // })
    },
    openLinkModal () {
      window.jQuery('#LinkTestimonyModal').modal({})
    },
    linkAll (selectedTestimonies) {
      async.eachOfSeries(selectedTestimonies, this.link, (err) => {
        if (err) console.error(err)
        this.getCase()
        this.$refs.testimoniesListRef.refresh(true)
        // this.$refs.timeline.getHistory()
        // this.getRelatedCases()
      })
    },
    link (selectedTestimony, index, callback) {
      const body = {
        testimonyId: selectedTestimony._id,
        version: selectedTestimony.version
      }
      return api.authenticatedRequest('post', `/cases/${this.id}/testimonies`, body)
        .then(response => {
          callback()
        })
        .catch(error => {
          console.log(error)
          callback(error)
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getCase()
    })
  }
}
</script>
<style>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'Font Awesome 5 Free';
}

table.dataTable thead .active:after {
    opacity: 0.5!important;
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
  opacity: 0.2;
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
  opacity: 0.2;
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
  opacity: 0.2;
}
</style>



// WEBPACK FOOTER //
// Case.vue?938e6528